import React from "react";
import { Mail, Phone, MapPin, Clock, Send } from 'lucide-react';
import SEO from '../Components/SEO';

const contactDetails = [
  {
    icon: <Mail className="w-5 h-5 text-blue-700" />,
    label: "Email",
    value: "datalawindia@gmail.com",
    sub: "We respond within 1–2 business days",
  },
  {
    icon: <Phone className="w-5 h-5 text-blue-700" />,
    label: "Phone",
    value: "",
    sub: "Mon – Fri, 10:00 AM – 6:00 PM IST",
  },
  {
    icon: <Clock className="w-5 h-5 text-blue-700" />,
    label: "Office Hours",
    value: "Monday – Friday",
    sub: "10:00 AM – 6:00 PM IST (Closed on public holidays)",
  },
];

export default function ContactUs() {
  return (
    <>
    <SEO
      title="Contact Us - DPDP Guide"
      description="Get in touch with the DPDP Guide team for questions about DPDP Act compliance, data protection guidance, and legal inquiries."
      keywords="contact DPDP Guide, DPDP help, data protection support, legal inquiry India"
    />
    <div
      className="min-h-screen w-full"
      style={{ background: 'linear-gradient(to bottom, #eff6ff, #ecfeff)', fontFamily: 'Inter, Arial, sans-serif' }}
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10 py-6 sm:py-10">

        {/* Page Header */}
        <div className="mb-10">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1 h-6 rounded bg-blue-700" />
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-700">Get in Touch</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3" style={{ letterSpacing: '-0.01em' }}>
            Contact Us
          </h1>
          <p className="text-gray-500 text-base max-w-xl">
            Have a question, feedback, or need assistance? Reach out and our team will be happy to help.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">

          {/* Left: Contact Detail Cards */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            {contactDetails.map((item, i) => (
              <div key={i} className="bg-white border border-gray-200 rounded-xl px-6 py-5 shadow-sm flex items-start gap-4">
                <div
                  className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: 'linear-gradient(135deg, #dbeafe, #cffafe)' }}
                >
                  {item.icon}
                </div>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-0.5">{item.label}</p>
                  <p className="text-gray-900 font-semibold text-sm">{item.value}</p>
                  <p className="text-gray-400 text-xs mt-0.5">{item.sub}</p>
                </div>
              </div>
            ))}

          </div>

          {/* Right: Direct Email CTA */}
          <div className="lg:col-span-3">
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
              <div className="h-1 w-full" style={{ background: 'linear-gradient(to right, #1d4ed8, #0891b2)' }} />
              <div className="px-8 py-12 flex flex-col items-center text-center">
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
                  style={{ background: 'linear-gradient(135deg, #dbeafe, #cffafe)' }}
                >
                  <Mail className="w-7 h-7 text-blue-700" />
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-2">Send Us an Email</h2>
                <p className="text-gray-500 text-sm leading-relaxed max-w-sm mb-8">
                  Write to us with your query, feedback, or compliance question and we will get back to you within 1–2 business days.
                </p>

                <a
                  href="mailto:datalawindia@gmail.com?subject=Enquiry%20via%20DPDP%20Platform"
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-lg text-white font-semibold text-sm shadow-sm hover:shadow-md transition"
                  style={{ background: 'linear-gradient(to right, #1d4ed8, #0891b2)' }}
                >
                  <Send className="w-4 h-4" />
                  Email Us Directly
                </a>

                <p className="mt-5 text-xs text-gray-400">Opens your email client · datalawindia@gmail.com</p>

                <div className="mt-10 pt-8 border-t border-gray-100 w-full grid grid-cols-2 gap-4 text-left">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">Response Time</p>
                    <p className="text-sm font-semibold text-gray-800">1–2 Business Days</p>
                  </div>
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-1">Office Hours</p>
                    <p className="text-sm font-semibold text-gray-800">Mon–Fri, 10am–6pm IST</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-gray-400 mt-10">
          © 2026 · We typically respond within 1–2 business days.
        </p>
      </div>
    </div>
    </>
  );
}
